import type { IObjectViewModel } from '../../../interfaces';
import { SceneItemKind } from '../../../interfaces';
import { AngleModel } from './Angle.model';
import { AngleIndicationStrategy } from './AngleIndicationStrategy';
import type { IIndicationStrategy } from '../Indications.controller';
import type { IIndicationToolFactory } from '../Indications.factory';
import type { IndicationsService } from '../Indications.service';
import type { IValue } from '@/engine/DataFlow/Graph';
import type { IIndicationsViewModelFactory } from '../interfaces';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';
import type { ICommandProcessor } from '../../core/interfaces/Command';
import type { IRemover } from '@/engine/UIPresentation/Interfaces';
import { BaseIndicationAdder } from '../distance/BaseIndicationAdder';

export class AngleToolFactory implements IIndicationToolFactory {
  private readonly _baseIndicationLabel = 'Angle';

  private readonly _indicationsService: IndicationsService;

  public constructor(indicationsService: IndicationsService) {
    this._indicationsService = indicationsService;
  }

  public createIndicationStrategy(
    planningAlgorithm: PlanningAlgorithm,
    commandProcessor: ICommandProcessor,
    remover: IRemover
  ): IIndicationStrategy {
    return new AngleIndicationStrategy(
      this._indicationsService,
      planningAlgorithm,
      commandProcessor,
      new BaseIndicationAdder(planningAlgorithm, this._indicationsService),
      remover
    );
  }

  public createIndicationModel(): IValue {
    return new AngleModel({});
  }

  public createIndicationViewModel(
    vmFactory: IIndicationsViewModelFactory,
    phaseId: string | undefined
  ): IObjectViewModel {
    return vmFactory.createViewModel(
      SceneItemKind.IndicatedAngle,
      phaseId,
      undefined,
      undefined,
      this._indicationsService.getIndicationLabel(this._baseIndicationLabel, SceneItemKind.IndicatedAngle)
    );
  }
}
